module.exports = __webpack_public_path__ + "img/logo-icon.01c903bf.svg";